import React, { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { formatCurrencyValue } from '@eika/currency-input';

import { GjeldAksjonWeb, GjeldTypeWeb } from '../../generated-types';
import { useTranslation } from '../../translations';
import { GjeldFormData } from './gjeld';

const GjeldSum: FC = () => {
    const { gjeld } = useTranslation();
    const { control } = useFormContext<GjeldFormData>();
    const value = useWatch({ name: 'gjeld', control });
    const gjeldUtlaan =
        value.length > 0
            ? value
                  .filter((g1) => g1.gjeldType !== GjeldTypeWeb.KREDITT)
                  .map((g2) => g2.restgjeld)
                  .reduce((prev, next) => Number(prev) + Number(next), 0)
            : 0;
    const gjeldKreditt =
        value.length > 0
            ? value
                  .filter((g1) => g1.gjeldType === GjeldTypeWeb.KREDITT)
                  .map((g2) => g2.kredittramme)
                  .reduce((prev, next) => Number(prev) + Number(next), 0)
            : 0;
    const gjeldInnfris =
        (value?.some((g) => g.aksjon === GjeldAksjonWeb.ERSTATTES) &&
            value
                ?.filter((g) => g.aksjon === GjeldAksjonWeb.ERSTATTES)
                .map((g) => g.restgjeld)
                .reduce((prev, next) => Number(prev) + Number(next), 0)) ||
        0;

    return (
        <div className="info-box">
            <span className="text-bold">{`${gjeld.infoGjeldSum}: ${formatCurrencyValue(
                (gjeldUtlaan || 0) + (gjeldKreditt || 0),
            )} kr`}</span>
            {gjeldInnfris > 0 && (
                <span className="text-bold">{`${gjeld.infoGjeldInfrisSum}: ${formatCurrencyValue(
                    gjeldInnfris,
                )} kr`}</span>
            )}
        </div>
    );
};

export default GjeldSum;
